<template>
  <div class="dashboard p-4">
    <!-- end nav -->
    <div class="mt-2 w-full">
      <div
        class="lg:flex grid-cols-1 lg:space-y-0 space-y-3 gap-5 justify-between"
      >
        <div>
          <!-- <p class="uppercase text-xs text-gray-700 font-semibold">overview</p> -->
          <h1 class="text-2xl text-gray-900 dark:text-gray-200 font-medium">
            Plant Data Monitoring
          </h1>
        </div>
        <div class="flex gap-2">
          <Modal
            title="Add Plant"
            btnTextSubmit="Add"
            btnType="submit"
            btnText="Crate new plant"
            @submitForm="()=>postNewPlant({varietas,taraf,ulangan,sensorIndex})"
          >
            <template v-slot:body>
              <div class="space-y-5 pb-1">
                <div class="space-y-3">
                  <p>Varietas</p>
                  <input
                    v-model="varietas"
                    required
                    type="text"
                    placeholder=""
                    class="p-2 border dark:border-gray-600 dark:bg-gray-700 w-full rounded outline-none"
                  />
                </div>
                <div class="space-y-3">
                  <p>Taraf Cekaman</p>
                  <input
                    v-model="taraf"
                    required
                    type="number"
                    placeholder=""
                    class="p-2 border dark:border-gray-600 dark:bg-gray-700 w-full rounded outline-none"
                  />
                </div>
                <div class="space-y-3">
                  <p>Ulangan</p>
                  <input
                    v-model="ulangan"
                    required
                    type="number"
                    placeholder=""
                    class="p-2 border dark:border-gray-600 dark:bg-gray-700 w-full rounded outline-none"
                  />
                </div>
                <div class="space-y-3">
                  <p>Sensor</p>
                  <input
                    v-model="sensorIndex"
                    required
                    type="text"
                    placeholder="v1-v420"
                    class="p-2 border dark:border-gray-600 dark:bg-gray-700 w-full rounded outline-none"
                  />
                  <ul class="overflow-y-auto max-h-40 border-gray-100 w-full mt-2 ">
                    <li v-if="sensorChose != sensorIndex" v-on:click="sensorIndex=item.name,sensorChose=sensorIndex" v-for="(item, index) in dataSensor" :key="index" class="pl-3 py-1 border-b-2 dark:text-white border-gray-100 relative cursor-pointer hover:dark:bg-green-900 hover:bg-green-100 hover:text-gray-900">
                        {{ item.name }}
                    </li>
                </ul>
                </div>
              </div>
            </template>
          </Modal>
        </div>
      </div>
    </div>
    <TableTanstack />
  </div>
  
</template>
<script>
  // @ is an alias to /src
  import { useCounterStore } from "@/store/counter";
  import { mapActions, mapState } from "pinia";
  import { Icon } from "@iconify/vue";
  import Modal from "@/components/modal.vue";
  import TableTanstack from "./TableTanstack.vue";

  export default {
    name: "Dashboard",
    components: {
      Icon,Modal, TableTanstack
    },
    data() {
      return {
        data: null,
        varietas: '',
        taraf: '',
        ulangan: '',
        sensorIndex: '',
        sensorChose: '',
      };
    },
    methods: {
      ...mapActions(useCounterStore,['getRealtimeSensor', 'getAllPlanst', 'postNewPlant','getDataSensor',]),
      fetchDataSensor() {
        this.getDataSensor(this.sensorIndex);
      },
    },
    computed: {
      ...mapState(useCounterStore,['dataSensor']),
      
    },
    created(){
      this.getRealtimeSensor(),
      this.getAllPlanst()
    },
    watch: {
      sensorIndex(newVal) {
        if (newVal) {
          if(this.sensorChose != this.sensorIndex){
            this.fetchDataSensor();
          }
        }
      },
    },
  };
</script>
